module.exports = {
      id: "group-usage",
      viewBox: "0 0 11 10",
      url: "/" + "sprite-4add775381efce29ef76f223dff77c00.svg#group",
      toString: function () {
        return this.url;
      }
    }